import React from "react";
import { useFormik } from "formik";

import { ITemp } from "../users-table";
import endpoints from "../../../../api/endpoints";
import usePutApi from "../../../../hooks/use-put-api";
import { showErrorToast, showSuccessToast } from "src/utils/toast";
import { useSyncGlobalPageLoader } from "../../../../contexts/global-page-loader-context";
import PasswordSchema, { IPasswordSchema } from "./schema/password.schema";

interface Props {
  openModal: boolean;
  toggleModal: () => void;
  rowData: ITemp;
}

const PasswordModal: React.FC<Props> = ({ openModal, toggleModal, rowData }) => {
  const { values, errors, handleChange, handleSubmit, handleBlur, resetForm } = useFormik<IPasswordSchema>({
    initialValues: {
      new_password: "",
      confirm_password: "",
      transaction_password: "",
      member_operation_type: "password",
    },
    onSubmit: (formValues) => {
      handlePasswordSubmit(formValues);
    },
    validationSchema: PasswordSchema,
  });

  const { putData, loading: putLoading } = usePutApi(endpoints.member.operation(rowData.id));

  useSyncGlobalPageLoader(putLoading);

  const handlePasswordSubmit = async (submitValues: IPasswordSchema) => {
    try {
      await putData(submitValues);
      showSuccessToast("Password changed successfully");
      toggleModal();
      resetForm();
    } catch (error: any) {
      const errorMessage = error?.data?.status_message;
      showErrorToast(errorMessage || "Someting Went Wrong");
      toggleModal();
      resetForm();
    }
  };

  if (!openModal) return null;

  return (
    <>
    {/* style={{ position: "absolute", zIndex: 1040 }} */}
      <div
        role="dialog"
        className="modal fade show"
        aria-modal="true"
        style={{ display: "block" }}
        onMouseDown={(event) => {
          if (event.target === event.currentTarget) {
            toggleModal();
          }
        }}
      >
        <div className="modal-dialog modal-md modal-dialog-scrollable">
          <span />
          <div className="modal-content" style={{ marginTop: "60px" }}>
            <header className="modal-header">
              <h4 className="modal-title">Password</h4>
              <button type="button" data-dismiss="modal" className="close text-white" onClick={toggleModal}>
                &times;
              </button>
            </header>
            <div className="modal-body">
              <form method="post" onSubmit={handleSubmit}>
                <div className="form-group row">
                  <label className="col-form-label col-4" htmlFor="userChangeNewPassword">New Password</label>
                  <div className="col-8 form-group-feedback form-group-feedback-right">
                    <input
                      id="userChangeNewPassword"
                      type="password"
                      name="new_password"
                      className={`form-control ${errors.new_password ? "is-invalid" : ""}`}
                      value={values.new_password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.new_password && (
                      <small className="error">{errors.new_password}</small>
                    )}
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-form-label col-4" htmlFor="userChangeConfirmPassword">Confirm Password</label>
                  <div className="col-8 form-group-feedback form-group-feedback-right">
                    <input
                      id="userChangeConfirmPassword"
                      type="password"
                      name="confirm_password"
                      className={`form-control ${errors.confirm_password ? "is-invalid" : ""}`}
                      value={values.confirm_password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.confirm_password && (
                      <small className="error">{errors.confirm_password}</small>
                    )}
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-form-label col-4" htmlFor="userChangeTransactionPassword">Transaction Password</label>
                  <div className="col-8 form-group-feedback form-group-feedback-right">
                    <input
                      id="userChangeTransactionPassword"
                      type="password"
                      name="transaction_password"
                      className={`form-control ${errors.transaction_password ? "is-invalid" : ""}`}
                      value={values.transaction_password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.transaction_password && (
                      <small className="error">{errors.transaction_password}</small>
                    )}
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-12 text-right">
                    <button type="button" className="btn btn-back" onClick={toggleModal}>
                      <i className="fas fa-undo mr-1" />
                      Back
                    </button>{" "}
                    <button type="submit" className="btn btn-primary">
                      Submit
                      <i className="fas fa-sign-in-alt ml-1" />
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <span />
        </div>
      </div>
      <div className="modal-backdrop" role="button" tabIndex={0} aria-label="Close password modal" onClick={toggleModal} />
    </>
  );
};

export default PasswordModal;
